import {styledByTheme} from "../../../../../../../themes/architecture/styled-by-theme";
import {VideoSlidesArenaFiltersIndicatorDefaultBox} from "./video-slides-arena-filters-indicator-default.box";


export const VideoSlidesArenaFiltersIndicatorBox = styledByTheme(VideoSlidesArenaFiltersIndicatorDefaultBox)
    .apply();